import { useContext, useEffect, useRef } from 'react';
import { RealtimeContext } from './realtimeContext';

export function useRealtime() {
  const ctx = useContext(RealtimeContext);
  if (!ctx) {
    throw new Error('useRealtime must be used within a RealtimeProvider');
  }
  return ctx;
}

/**
 * Register a handler for normalized realtime events on a domain.
 * Handlers are deduped per mount via ref so you can pass inline functions.
 *
 * @param {string} domain — e.g. REALTIME_DOMAINS.WILDCARD for all events
 * @param {(event: { domain: string, type: string, payload: unknown, meta: object }) => void} handler
 */
export function useRealtimeDomain(domain, handler) {
  const { registerDomainHandler } = useRealtime();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    return registerDomainHandler(domain, (event) => {
      handlerRef.current(event);
    });
  }, [domain, registerDomainHandler]);
}
